export default __webpack_public_path__ + "static/media/hamburger.40ccf49d.svg";